import type { Editor } from '@tiptap/react';

const RENDERED_BAND_CLASSES = ['tiptap-page-header', 'tiptap-page-footer'];
const OVERLAY_BAND_CLASSES = ['tiptap-header-editor-container', 'tiptap-footer-editor-container'];

const selector = (classes: string[], descendant = ''): string =>
  classes.map((name) => `.${name}${descendant}`).join(', ');

export const RENDERED_BAND_SELECTOR = selector(RENDERED_BAND_CLASSES);
export const HEADER_FOOTER_PANEL_ATTR = 'data-header-footer-panel';
export const HEADER_FOOTER_PANEL_SELECTOR = `[${HEADER_FOOTER_PANEL_ATTR}]`;
export const BAND_SELECTOR = selector([...RENDERED_BAND_CLASSES, ...OVERLAY_BAND_CLASSES]);
export const HEADER_FOOTER_IMG_SELECTOR = selector([...RENDERED_BAND_CLASSES, ...OVERLAY_BAND_CLASSES], ' img');

const OVERLAY_SELECTOR = selector(OVERLAY_BAND_CLASSES);

// The body goes non-editable while a band is open, and the overlay is portaled outside its DOM.
export const getHeaderFooterRoot = (editor: Editor): Document | HTMLElement =>
  !editor.isEditable && editor.isInitialized && !editor.isDestroyed && !document.querySelector(OVERLAY_SELECTOR)
    ? editor.view.dom
    : document;
